// Click and drag with the mouse to scroll any row (or list) that has arrows; touch and the wheel keep working as usual.
(() => {
  'use strict';
  const ROWS = '.social-reels__viewport, .recipe-related-track, .product-extras__track, .gallery-thumbnails, .home-recipes__viewport, .featured-items__grid, .recipe-story__related-grid, .partner-spotlight__tabs, .product-reviews__photos, .restaurant-menus__viewport, [data-drag-scroll]';
  const LISTS = '[data-drag-scroll-y]';
  const THRESHOLD = 6;

  const attach = (el, vertical) => {
    if (el.dataset.dragReady) return;
    el.dataset.dragReady = 'true';
    const size = () => vertical ? el.scrollHeight > el.clientHeight + 2 : el.scrollWidth > el.clientWidth + 2;
    const mark = () => el.classList.toggle('is-draggable', size());
    mark();
    window.addEventListener('resize', mark);
    if ('ResizeObserver' in window) new ResizeObserver(mark).observe(el);

    let start = 0, origin = 0, dragging = false, moved = false, id = null;
    el.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !size()) return;
      if (e.target.closest('input, textarea, select, video[controls]')) return;
      start = vertical ? e.clientY : e.clientX;
      origin = vertical ? el.scrollTop : el.scrollLeft;
      dragging = true; moved = false; id = e.pointerId;
    });
    el.addEventListener('pointermove', e => {
      if (!dragging || e.pointerId !== id) return;
      const delta = (vertical ? e.clientY : e.clientX) - start;
      if (!moved && Math.abs(delta) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        el.classList.add('is-dragging');
        el.setPointerCapture(id);
      }
      // Snapping and smooth scrolling would fight the drag, so they pause until release
      if (vertical) el.scrollTop = origin - delta; else el.scrollLeft = origin - delta;
    });
    const end = e => {
      if (!dragging || (e && e.pointerId !== id)) return;
      dragging = false;
      el.classList.remove('is-dragging');
      if (moved) {
        // The click that ends a drag must not open the card underneath
        const stop = ev => { ev.preventDefault(); ev.stopPropagation(); };
        el.addEventListener('click', stop, { capture: true, once: true });
        setTimeout(() => el.removeEventListener('click', stop, { capture: true }), 0);
      }
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    // Pictures and links would start the browser's own drag instead
    el.addEventListener('dragstart', e => e.preventDefault());
  };

  const scan = () => {
    document.querySelectorAll(ROWS).forEach(el => attach(el, false));
    document.querySelectorAll(LISTS).forEach(el => attach(el, true));
  };
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();